module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "calibre_pb_0"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00002",
      "title": "[vii]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_vii",
      "title": "[vii]"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "calibre",
    attrs: {
      "id": "pgepubid00003"
    }
  }, [_vm._v("CONTENTS.")]), _vm._v(" "), _c('div', {
    staticClass: "center2"
  }, [_c('table', {
    staticClass: "toc",
    attrs: {
      "border": "0",
      "cellpadding": "1",
      "cellspacing": "0",
      "summary": "Contents"
    }
  }, [_c('tbody', {
    staticClass: "calibre8"
  }, [_c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_vm._v("PAGE")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("PROLOGUE")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter1"
  }, [_vm._v("CHAP.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("I.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("THE SURRENDER OF THE WORLD-THRONE")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0006#Page_8"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("II.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("A CROWNLESS KING")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0007#Page_14"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("III.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("TSARINA OLGA")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0008#Page_26"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("IV.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("A SON OF THE GODS")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0009#Page_35"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("V.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("A VISION FROM THE CLOUDS")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0010#Page_47"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("VI.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("DEED AND DREAM")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0011#Page_53"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("VII.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("THE SPELL OF CIRCE")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012#Page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("VIII.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("THE NEW TERROR")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013#Page_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("IX.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("THE FLIGHT OF THE “REVENGE”")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014#Page_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("X.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("STRANGE TIDINGS TO AERIA")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015#Page_94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XI.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("THE SNAKE IN EDEN")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016#Page_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XII.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("THE BATTLE OF KERGUELEN")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0017#Page_110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XIII.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("THE SYREN’S STRONGHOLD")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018#Page_129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XIV.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("FROM THE SEA TO THE AIR")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0019#Page_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XV.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("OLGA IN COUNCIL")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0020#Page_146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XVI.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("KHALID THE MAGNIFICENT")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0021#Page_159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("159")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XVII.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("AN UNHOLY ALLIANCE")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0022#Page_174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("174")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("A MOMENTOUS COMMISSION")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0023#Page_188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("188")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XIX.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("FACE TO FACE AGAIN")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0024#Page_202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("202")]), _c('span', {
    attrs: {
      "id": "pgepubid00004",
      "title": "[viii]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_viii",
      "title": "[viii]"
    }
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XX.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("THE CALL TO ARMS")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0025#Page_215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("215")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XXI.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("THE HOME-COMING")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0026#Page_226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("226")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XXII.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("THE EVE OF BATTLE")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0027#Page_243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("243")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XXIII.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("THE FIRST BLOW")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0028#Page_253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("253")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XXIV.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("WAR AT ITS WORST")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0029#Page_271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("271")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XXV.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("A MESSAGE FROM MARS")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0030#Page_289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("289")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XXVI.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("SENTENCE OF DEATH")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0031#Page_303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("303")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XXVII.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("ALMA SPEAKS")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0032#Page_314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("314")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XXVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("THE SIGN IN THE SKY")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0033#Page_319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("319")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XXIX.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("THE TRUCE OF GOD")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0034#Page_325",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("325")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XXX.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("THE SHADOW OF DEATH")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0035#Page_338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("338")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XXXI.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("THE LAST BATTLE")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0036#Page_350",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("350")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }, [_vm._v("XXXII.")]), _vm._v(" "), _c('td', {
    staticClass: "toctitle"
  }, [_vm._v("THE SHE-WOLF TO HER LAIR")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0037#Page_359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("359")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre9"
  }, [_c('td', {
    staticClass: "tocchapter"
  }), _vm._v(" "), _c('td', {
    staticClass: "toctitle1"
  }, [_vm._v("EPILOGUE")]), _vm._v(" "), _c('td', {
    staticClass: "tocpage"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0038#Page_369",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("369")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-157e0c0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0